module.exports = __webpack_public_path__ + "@/assets/img/youtube.57bf780e.svg";